<template>
    <svg data-name="Camada 1" xmlns="http://www.w3.org/2000/svg" viewBox="25 25 150 150">
        <path
            class="cls-1"
            d="M131.16,95a2.5,2.5,0,0,1-2.5-2.5V43H87.83V62.61a2.5,2.5,0,1,1-5,0V40.54a2.49,2.49,0,0,1,2.5-2.49h45.82a2.48,2.48,0,0,1,2.49,2.49v52A2.49,2.49,0,0,1,131.16,95Z"
        />
        <path
            class="cls-1"
            d="M78.14,161.54h0a25.4,25.4,0,0,1-18-43.36L81.36,97a5.09,5.09,0,0,0,1.48-3.59V73.45a2.5,2.5,0,1,1,5,0V93.39a10,10,0,0,1-3,7.12L63.7,121.71a20.41,20.41,0,0,0,14.43,34.84h0a20.28,20.28,0,0,0,14.43-6L121,122.18a26.07,26.07,0,0,0,7.7-18.58,2.5,2.5,0,1,1,5,0,31.06,31.06,0,0,1-9.16,22.11L96.1,154.1A25.23,25.23,0,0,1,78.14,161.54Z"
        />
        <path
            class="cls-1"
            d="M85.34,54.54a2.5,2.5,0,0,1-2.5-2.5V40.54a2.5,2.5,0,0,1,5,0V52A2.5,2.5,0,0,1,85.34,54.54Z"
        />
        <path
            class="cls-1"
            d="M96.79,54.54A2.49,2.49,0,0,1,94.3,52V40.54a2.5,2.5,0,0,1,5,0V52A2.5,2.5,0,0,1,96.79,54.54Z"
        />
        <path
            class="cls-1"
            d="M108.25,54.54a2.5,2.5,0,0,1-2.5-2.5V40.54a2.5,2.5,0,0,1,5,0V52A2.49,2.49,0,0,1,108.25,54.54Z"
        />
        <path
            class="cls-1"
            d="M119.7,54.54a2.49,2.49,0,0,1-2.49-2.5V40.54a2.5,2.5,0,0,1,5,0V52A2.5,2.5,0,0,1,119.7,54.54Z"
        />
        <path
            class="cls-1"
            d="M94.34,154.83a2.49,2.49,0,0,1-1.77-.73l-32.4-32.39a2.5,2.5,0,1,1,3.53-3.53l32.4,32.4a2.49,2.49,0,0,1-1.76,4.25Z"
        />
        <path
            class="cls-1"
            d="M119.86,127.74a2.45,2.45,0,0,1-1.39-.43A22.69,22.69,0,0,1,131.16,85.8a2.5,2.5,0,0,1,0,5,17.71,17.71,0,0,0-9.9,32.39,2.49,2.49,0,0,1-1.4,4.56Z"
        />
    </svg>
</template>

<script>
    export default {
        name: 'SockIcon',
    };
</script>
